// @ts-ignore
import {version} from '../../package.json';

export const userToken = () => JSON.parse(localStorage.getItem('accessToken')).access_token || localStorage.getItem('accessToken');

export const getHeaders = () =>
    new Headers({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache',
        'Authorization': `Bearer ${userToken()}`,
    });

export const getVersion = (): string  => version;
